import { SettingsPage } from '@/admin-design/_common/settings'
import { PageHeader } from '@/ui'
import BlueskyPanel from '../accounts/BlueskyPanel'

/** /settings: the server's own settings panels (what the manifest declares:
 *  import, groups, about) under the console's header. The panels are
 *  _common's and keep their own tabs; Bluesky is a custom panel because the
 *  common form would preview the app password. The same panel also sits on
 *  the accounts page.
 *
 *  _common prints its own "Settings" title and version badge first; the
 *  title is hidden so the page has one heading, the badge stays. */
export default function Settings() {
  return (
    <>
      <PageHeader title="설정" />
      <div className="[&_h1]:sr-only [&>div]:!max-w-none [&>div]:!p-0">
        <SettingsPage customRegistry={{ bluesky: BlueskyPanel }} />
      </div>
    </>
  )
}
